import { useTranslation } from 'react-i18next';

import { faClock } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { I18NextNS } from 'src/models/Language.model';

import InfoCardTemplate from './InfoCardTemplate';

export default function TakingTooLongInfoCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.infoCards.takingTooLong',
  });

  return (
    <InfoCardTemplate
      icon={<FontAwesomeIcon icon={faClock} className="text-primary" />}
      backgroundColor="primary-100"
      borderColor="primary"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="info-taking-too-long"
    />
  );
}
